import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';

const TooltipRate = ({ t, position }) => {
  return (
    <div
      id="tooltipRate"
      className={`tooltip fade bs-tooltip-right tooltipTransform ${_.isEmpty(position) ? '' : 'show'}`}
      style={{ top: position.y - 100, left: position.x + 50 }}
    >
      <div className="im-rate-list">
        <div className="im-rate-list__item">
          <div className="im-rate">
            <div className="im-rate__point im-rate__point__first im-rate__point--green" />
            <div className="im-rate__point im-rate__point--green" />
            <div className="im-rate__point im-rate__point--green" />
            <div className="im-rate__point im-rate__point__last im-rate__point--green" />
          </div>
          <div>
            {t('tooltipText4')}
          </div>
        </div>
        <div className="im-rate-list__item">
          <div className="im-rate">
            <div className="im-rate__point im-rate__point__first im-rate__point--green" />
            <div className="im-rate__point im-rate__point--green" />
            <div className="im-rate__point im-rate__point--green" />
            <div className="im-rate__point im-rate__point__last" />
          </div>
          <div>
            {t('tooltipText3')}
          </div>
        </div>
        <div className="im-rate-list__item">
          <div className="im-rate">
            <div className="im-rate__point im-rate__point__first im-rate__point--yellow" />
            <div className="im-rate__point im-rate__point--yellow" />
            <div className="im-rate__point" />
            <div className="im-rate__point im-rate__point__last" />
          </div>
          <div>
            {t('tooltipText2')}
          </div>
        </div>
        <div className="im-rate-list__item">
          <div className="im-rate">
            <div className="im-rate__point im-rate__point__first im-rate__point--red" />
            <div className="im-rate__point" />
            <div className="im-rate__point" />
            <div className="im-rate__point im-rate__point__last" />
          </div>
          <div>
            {t('tooltipText1')}
          </div>
        </div>
      </div>
    </div>
  );
};

TooltipRate.propTypes = {
  t: PropTypes.func,
  position: PropTypes.object,
};

export default withTranslation('common')(TooltipRate);
